import { useQuery } from "@apollo/client";
import { Select, Text } from "@aurem/ui";
import {
  clearStoredTenant,
  getStoredTenant,
  setStoredTenant,
} from "@aurem/utils";
import { useState } from "react";
import { gql } from "types";
import { DevToolbarCard } from "./DevToolbarCard";

const TENANTS_LIST = gql(/* GraphQL */ `
  query DevToolbarTenantsList {
    tenantsList {
      id
      name
    }
  }
`);

const DEFAULT_TENANT_OPTION = "default";

export const TenantSelectorCard = () => {
  const [selectedTenant, setSelectedTenant] = useState<string>(
    getStoredTenant() ?? DEFAULT_TENANT_OPTION,
  );

  const { data, loading } = useQuery(TENANTS_LIST);

  const options = [
    { id: DEFAULT_TENANT_OPTION, text: "default (from HTML)" },
    ...(data?.tenantsList ?? []).map((tenant) => ({
      id: tenant.name,
      text: tenant.name,
    })),
  ];

  const handleChange = (value: string | undefined) => {
    if (!value || value === selectedTenant) return;
    setSelectedTenant(value);
    if (value === DEFAULT_TENANT_OPTION) {
      clearStoredTenant();
    } else {
      setStoredTenant(value);
    }
    window.location.reload();
  };

  return (
    <DevToolbarCard title="Tenant" testId="devtoolbar-tenant-selector">
      <div className="flex flex-col gap-2">
        <Text size="xs" className="text-gray500">
          Select the active tenant. The page will reload to apply the change.
        </Text>
        <Select
          options={options}
          value={selectedTenant}
          onChange={handleChange}
          loading={loading}
          placeholder="Select tenant"
          size="sm"
          data-e2e-id="devtoolbar-tenant-selector-select"
        />
      </div>
    </DevToolbarCard>
  );
};
